import type { DeepPartial } from '@luna/utils-ts';

import type { Documents } from '../../types/Documents';

export const documentsHRFeatureConfig: DeepPartial<Documents> = {
    requestForTitleDocuments: true,
};
